/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReelBusiness
 */
export interface ReelBusiness {
    /**
     * 
     * @type {string}
     * @memberof ReelBusiness
     */
    readonly id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReelBusiness
     */
    readonly is_pro: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReelBusiness
     */
    readonly name: string;
    /**
     * 
     * @type {number}
     * @memberof ReelBusiness
     */
    readonly favorite_count: number;
}

/**
 * Check if a given object implements the ReelBusiness interface.
 */
export function instanceOfReelBusiness(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "is_pro" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "favorite_count" in value;

    return isInstance;
}

export function ReelBusinessFromJSON(json: any): ReelBusiness {
    return ReelBusinessFromJSONTyped(json, false);
}

export function ReelBusinessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReelBusiness {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'is_pro': json['is_pro'],
        'name': json['name'],
        'favorite_count': json['favorite_count'],
    };
}

export function ReelBusinessToJSON(value?: ReelBusiness | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

